module.exports = __webpack_public_path__ + "img/20170704_135648_095.b749e7c7.jpg";